/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Responsible_User_GroupInputs */

const en_forms_teams_responsible_user_group = /** @type {(inputs: Forms_Teams_Responsible_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronized User Group for Team Responsible`)
};

const de_forms_teams_responsible_user_group = /** @type {(inputs: Forms_Teams_Responsible_User_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Synchronisierte Benutzergruppe für Teamverantworliche`)
};

/**
* | output |
* | --- |
* | "Synchronized User Group for Team Responsible" |
*
* @param {Forms_Teams_Responsible_User_GroupInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_responsible_user_group = /** @type {((inputs?: Forms_Teams_Responsible_User_GroupInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Responsible_User_GroupInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_responsible_user_group(inputs)
	return de_forms_teams_responsible_user_group(inputs)
});